module.exports = __webpack_public_path__ + "img/pr-19.dc0d7e97.png";